import {
	Button,
	Col,
	ConfigProvider,
	Form,
	Input,
	Row,
	Space,
	Typography
} from 'antd'
import React, { useEffect, useRef } from 'react'
import { GeneralTitle } from '../../components/Shared'
import TextArea from 'antd/es/input/TextArea'
import { useStores } from '../../cls/stores/MobXProvider'
import { actSendMail } from '../../stores/users/actions'
import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router-dom'
import { GeneralContentWrapper } from '../../components/Shared/GeneralComponents'
import { isMobile } from 'react-device-detect'
import { translate } from '../../cls/TranslationContext'

const { Title, Paragraph } = Typography

const ContactUs = () => {
	const [form] = Form.useForm()
	const { users } = useStores()
	const { loggedInUser } = users
	const messageRef = useRef(null)
	const location = useLocation()

	// Function to get query parameters
	const getQueryParams = (search) => {
		return new URLSearchParams(search)
	}

	// Get email and username from query parameters
	const queryParams = getQueryParams(location.search)
	const emailTo = queryParams.get('email')
	const emailToUsername = queryParams.get('user_name')

	// Disable the email field if the user is logged in and has an email
	const isEmailFieldDisabled = loggedInUser?.email ? true : false

	// Set initial form values based on the logged-in user
	const _initialFormValues = {
		email: loggedInUser?.email || '',
		subject: '',
		comment: ''
	}

	useEffect(() => {
		emailToUsername &&
			form.setFieldsValue({
				comment: `Dear, ${emailToUsername}`
			})

		emailTo &&
			form.setFieldsValue({
				email_to: emailTo
			})
	}, [emailToUsername])

	/**
	 * Handles form submission for saving contact form data
	 *
	 * @param {Object} vals - The form values.
	 */
	const _doSave = (vals) => {
		if (vals !== null) {
			actSendMail(vals)
				.then((response) => {
					// console.log('response', response)

					// Set success message
					messageRef.current.style.color = 'green'
					messageRef.current.textContent =
						response?.message || translate('single.message-sent')

					// Clear the form
					form.resetFields()
				})
				.catch((error) => {
					// Set error message
					messageRef.current.style.color = 'red'
					messageRef.current.textContent =
						error?.message ||
						translate('single.message-sent-failed') // TODO: sombody added response?.message here instead of error.m find out if we send message key.
				})
			// console.log('--- Contact us', vals)
		}
	}

	return (
		<GeneralContentWrapper>
			<GeneralTitle text={translate('webacit.moto.contact')} />
			<ConfigProvider>
				<Form
					layout="vertical"
					form={form}
					name="contact-us"
					initialValues={_initialFormValues}
					onFinish={_doSave}
				>
					<Row
						gutter={[50, 50]}
						justify="space-between"
						align="middle"
					>
						<Col xs={24} sm={24} md={17} lg={17}>
							<Space
								style={{ width: '100%' }}
								direction="vertical"
							>
								<Title
									level={5}
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '5px'
									}}
								>
									<span>
										{translate('webackit.moto.ask')}
									</span>{' '}
									{/*todo: translate*/}
									<img
										width="30px"
										src={`${process.env.PUBLIC_URL}/webackit-logo-color.svg`}
										alt="webackit"
									/>
									<span
										style={{
											color: '#4846f4'
										}}
									>
										webackit
									</span>
								</Title>
								<Paragraph>
									{translate('webackit.moto.info')}
								</Paragraph>

								<div>
									<Form.Item
										label={translate('single.email')}
										tooltip={translate(
											'single.reach.email'
										)}
										name="email"
										rules={[
											{
												required: true,
												message: translate(
													'__provide.please%_email.address'
												)
											}
										]}
									>
										<Input
											disabled={isEmailFieldDisabled}
										/>
									</Form.Item>
									{emailTo && (
										<Form.Item
											label={translate(
												'__sending-x-to%single.email'
											)}
											tooltip={translate(
												'single.contacted-user'
											)}
											name="email_to"
											rules={[
												{
													required: true,
													message: translate(
														'__provide.please%_email.address'
													)
												}
											]}
										>
											<Input disabled={true} />
										</Form.Item>
									)}
									<Form.Item
										label={translate('single.subject')}
										tooltip={translate(
											'single.mail.subject'
										)}
										name="subject"
										rules={[
											{
												required: true,
												message: translate(
													'__provide.please%single.subject'
												)
											}
										]}
									>
										<Input showCount max={100} />
									</Form.Item>
									<Form.Item
										label={translate('single.description')}
										tooltip={translate(
											'__details%single.message'
										)}
										name="comment"
										rules={[
											{
												required: true,
												message: translate(
													'__enter.please%__your&single.message'
												)
											}
										]}
									>
										<TextArea
											rows={5}
											showCount
											maxLength={2000}
										/>
									</Form.Item>

									<Form.Item style={{ marginBottom: 0 }}>
										<Button
											type="primary"
											htmlType="submit"
										>
											{translate('single.submit')}
										</Button>
										<span
											ref={messageRef}
											style={{ marginLeft: 16 }}
										></span>
									</Form.Item>
								</div>
							</Space>
						</Col>
						{!isMobile && (
							<Col xs={24} sm={24} md={7} lg={7}>
								<img
									width="100%"
									src={`${process.env.PUBLIC_URL}/webackit-logo-color.svg`}
									alt="webackit"
								/>
							</Col>
						)}
					</Row>
				</Form>
			</ConfigProvider>
		</GeneralContentWrapper>
	)
}

export default observer(ContactUs)
